<template>
  <v-chip close
          v-model="chip"
          outline
          color="accent">
    <span v-if="schedule.text === 'private_parking_products_allDay'">{{ $t(schedule.text) }}</span>
    <span v-else>{{ schedule.text }}</span>
  </v-chip>
</template>
<script>
export default {
  name: 'VChipClosableWrapper',
  props: ['weekday', 'schedule'],
  watch: {
    chip: function(value) {
      if (!value) {
        this.$emit('close-event', {});
      }
    }
  },
  data: function() {
    return {
      chip: true
    };
  }
};
</script>




// WEBPACK FOOTER //
// src/components/commons/VChipClosableWrapper.vue